module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<style>\r\n    #instanceName input[type=checkbox], input[type=radio]{\r\n        margin-right:4px!important;\r\n    }\r\n</style>\r\n<form>\r\n<div class=\"row\" id=\"")
    ; __append(escapeFn(PropId))
    ; __append("\">\r\n    <div class=\"prop-header\"><span class=\"prop-label\">")
    ; __append(escapeFn(viewTitle))
    ; __append("</span></div>\r\n    <div class=\"col-md-12 prop-separator-0 form-group-flex\">\r\n        <input type=\"radio\" name=\"selectedValue\" value=\"literal\" class=\"valueType form-radio-group\" id=\"textOrNumber\" tabindex=\"16\"/>\r\n        <label class=\"form-group-label\">Text or Number</label>\r\n    </div>\r\n    <div class=\"col-md-12 nopadding-r prop-separator-1\">\r\n        <input type=\"text\" name=\"TextOrNumber\" id=\"TextOrNumber\" disabled class=\"valueSelect\" data-value-type=\"literal\" value=\"")
    ; __append(escapeFn(textOrNumberValue))
    ; __append("\" tabindex=\"17\"/>\r\n    </div>\r\n\r\n    <div class=\"col-md-12 prop-separator-0 form-group-flex\">\r\n        <input type=\"radio\" name=\"selectedValue\" value=\"field\" class=\"valueType form-radio-group\" tabindex=\"18\"/>\r\n        <label class=\"form-group-label\">Value of a Field</label>\r\n    </div>\r\n\r\n    <div class=\"col-md-12 nopadding-r  prop-separator-1\">\r\n        <div class=\"col-md-9 nopadding\" style=\"padding-right:4px!important;\">\r\n            ")
    ; 
                var display = fieldName;
                
                if(fieldDisplayName === "selectedValueFieldName"){
                    display = selectedValueFieldName;
                }
                else{
                     if(fieldDisplayName === "selectedInstanceFieldName"){
                        display = selectedInstanceFieldName;
                     }
                }
            
    ; __append("\r\n            <input type=\"text\" name=\"selectedValue\" id=\"ValueOfAField\" disabled value=\"")
    ; __append(escapeFn( display))
    ; __append("\" tabindex=\"19\" />\r\n        </div>\r\n        <div class=\"col-md-3 nopadding\" style=\"text-align: right;\">\r\n            <button id=\"ValueOfAFieldButton\" name=\"ValueOfAFieldButton\" class=\"btn btn-default hvr-glow valueSelect select-button\" data-value-type=\"field\"  disabled tabindex=\"20\">Select</button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-12 prop-separator-0 form-group-flex\">\r\n        <input type=\"radio\" name=\"selectedValue\" value=\"special\" class=\"valueType form-radio-group\" tabindex=\"21\"/>\r\n        <label class=\"form-group-label\">Special</label>\r\n    </div>\r\n    <div class=\"col-md-12 nopadding-r  prop-separator-1\">\r\n        <select name=\"Special\" id=\"specialValue\" disabled class=\"valueSelect\" data-value-type=\"special\" tabindex=\"22\">\r\n            ")
    ;  for (var i = 0; i < specialInstance.length; i++) {
            if (specialInstance[i] === '──────────') {
    ; __append("\r\n            <option disabled value=\"")
    ; __append(escapeFn(specialInstance[i].value))
    ; __append("\">")
    ; __append(escapeFn(specialInstance[i].text))
    ; __append("</option>\r\n            ")
    ;     } else { 
    ; __append("\r\n            <option value=\"")
    ; __append(escapeFn(specialInstance[i].value))
    ; __append("\"  >")
    ; __append(escapeFn(specialInstance[i].text))
    ; __append("</option>\r\n            ")
    ;    }
            }; 
    ; __append("\r\n        </select>\r\n    </div>\r\n\r\n    <div class=\"col-md-12 prop-separator-0 form-group-flex\">\r\n        <input type=\"radio\" name=\"selectedValue\" value=\"expression\" class=\"valueType form-radio-group\" tabindex=\"23\"/>\r\n        <label class=\"form-group-label\">Formula</label>\r\n    </div>\r\n    <div class=\"col-md-12\" >\r\n        <div class=\"col-md-4 nopadding-l  prop-separator-1\" style=\"display: inline-grid;\">\r\n            <button name=\"Formula\" id=\"Formula\" class=\"btn btn-default hvr-glow valueSelect\" data-value-type=\"expression\" disabled tabindex=\"24\">Compose</button>\r\n        </div>\r\n        <div class=\"col-md-7\"></div>\r\n    </div>\r\n</div>\r\n</form>")
  }
  return __output;

}